import WoocommerceAppDrawer from './WoocommerceAppDrawer';
import WoocommerceConnectDrawer from './WooCommerceConnectDrawer';

const drawers = [WoocommerceAppDrawer, WoocommerceConnectDrawer];

export default drawers;
